// KeepAliveWrapper.js
import React, { useEffect, useRef, useState } from 'react';

const UNMOUNT_DELAY = 10 * 60 * 1000;

export default function KeepAliveWrapper({ tab, activeTab, children, onDrop }) {
  const [shouldRender, setShouldRender] = useState(true);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (tab.pageCode === activeTab) {
      clearTimeout(timeoutRef.current);
      setShouldRender(true);
    } else {
      timeoutRef.current = setTimeout(() => {
        setShouldRender(false);
        onDrop?.(tab.pageCode);
      }, UNMOUNT_DELAY);
    }

    return () => clearTimeout(timeoutRef.current);
  }, [activeTab, tab.pageCode]);

  return shouldRender ? children : null;
}
